import React, { PureComponent } from 'react';
import Flicking from "@egjs/react-flicking";

class UseTip extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            currentPage : 0,
        }
    }

    clickClose() {
		//console.log("click!!")
        this.props.closeUseTip()
    }

    setExpries() {
        this.props.setExpires()
    }

	clickPageDot(index) {
        this.carousel.moveTo(index,500)
    }

	changePageDot() {
        //console.log(this.carousel.getIndex())
        this.setState({
            currentPage : this.carousel.getIndex(),
        })
    }

    render() {
		const totalPages = 4;

		let pagination = () => {
            let ret = [];

            //console.log(this.state.currentPage)

            for (let i =0; i < totalPages; i++) {
                if (this.state.currentPage === i) {
                    ret[i] = <li className="checked" key={i}></li>
                } else {
                    ret[i] = <li onClick={() => this.clickPageDot(i)} key={i}></li>
                }
            }
            return ret;
        }
		
        const inlineStyle = {
            display : "block"
        }
        return (
            <React.Fragment>
            <div className="dimmed guide" style={inlineStyle}></div>
            <div className="layer_wrap guide" style={inlineStyle} >
                <div className="layer_inner"  onClick={() => this.clickClose()}>
                    <div className="layer_cont">
                        <div className="layer_btn_group">
                            { this.props.showExpiresBtn && (
                                <button type="button" className="btn_never_view" onClick={() => this.setExpries()}>30일간 다시 보지 않기</button>
                            )}
                            <button type="button" className="btn_ly_close" onClick={() => this.clickClose()}>닫기</button>
                        </div>
						
						<Flicking ref={carousel => {this.carousel = carousel}}
							tag = "div"
							viewportTag = "div"
							cameraTag = "div"
							classPrefix = "eg-flick"
							deceleration = {0.0075}
							horizontal = {true}
							circular = {false}
							infinite = {false}
							infiniteThreshold = {0}
							lastIndex = {Infinity}
							threshold = {20}
							duration = {500}
							panelEffect = {x => 1 - Math.pow(1 - x, 3)}
							defaultIndex = {0}
							inputType = {["touch", "mouse"]}
							thresholdAngle = {45}
							bounce = {['10', '10']}
							autoResize = {true}
							adaptive = {false}
							bound = {false}
							overflow = {false}
							hanger = {0}
							anchor = {0}
							gap = {5}
							zIndex = {201}
							moveType = {{type: "snap", count: 1}}
							collectStatistics = {false}
							onMoveEnd={() => this.changePageDot()}>
							<div className="tip1" />
							<div className="tip2" />
							<div className="tip3" />
							<div className="tip4" onClick={() => this.clickClose()}/>
						</Flicking>
						<div className="pagination">
							<ul>{pagination()}</ul>
						</div>
					</div>
                </div>
            </div>
            </React.Fragment>
        );
    }
};

export default UseTip;